import { ServiceOutline18Icon } from "@vygruppen/spor-icon-react";
import { CustomOutlineBadge } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/Badges";
import { PRODUCTION_DEVIATION_LOCATION_HASH } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/EventsOverviewButtonAndModal";
import {
  getTrainMapName,
  useTabsForRole,
} from "features/CenterContent/RoleContent/useTabsForRole";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DropsButton, Flex, Text } from "shared/components/Spor";
import { useDropsRole } from "stores/useDropsRole";

type ProductionDeviationButtonProps = {};

export const ProductionDeviationButton: FC<
  ProductionDeviationButtonProps
> = () => {
  const { role } = useDropsRole();
  const tabsForRole = useTabsForRole(role);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isVaktleder } = useDropsRole();
  if (isVaktleder()) {
    return (
      <DropsButton
        variant="tertiary"
        leftIcon={<ServiceOutline18Icon />}
        size="xs"
        onClick={() => {
          // We need to search for the trainmap name and retrieve its id. That id will either be "togkart" or "start"
          const trainMapTab =
            tabsForRole?.find((it) => it.name === getTrainMapName(t))?.id ??
            "start";
          void navigate(
            `/dashboard/landing/${role}/${trainMapTab}${PRODUCTION_DEVIATION_LOCATION_HASH}`,
          );
        }}
        as="span"
        minW="max-content"
      >
        <Text fontSize="14px">{t("Produksjonsavvik")} →</Text>
      </DropsButton>
    );
  }
  return (
    <CustomOutlineBadge>
      <Flex alignItems="center" gap="6px">
        <ServiceOutline18Icon />
        <Text fontSize="14px">{t("Produksjonsavvik")}</Text>
      </Flex>
    </CustomOutlineBadge>
  );
};
